export default class {
    constructor(type) {
        this.type = type;
    }
    buildPatterns(arg) {
        if (arg.propertyPath) {
            return this.buildPropertyShapePatterns(arg);
        }
        return this.buildNodeShapePatterns(arg);
    }
    buildNodeShapePatterns(arg) {
        return this.buildPropertyShapePatterns(arg);
    }
}
export function assertList(arg) {
    if (!('list' in arg)) {
        throw new Error('Value must be an RDF List');
    }
}
export function assertTerm(arg) {
    if (!('pointer' in arg)) {
        throw new Error('Value must not be a RDF List');
    }
}
